"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentReplyDto = exports.CommentReplyAuthorDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const CommentAttachment_dto_1 = require("./CommentAttachment.dto");
class CommentReplyAuthorDto {}
exports.CommentReplyAuthorDto = CommentReplyAuthorDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentReplyAuthorDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentReplyAuthorDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentReplyAuthorDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  nullable: true
}), __metadata("design:type", Object)], CommentReplyAuthorDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AccountKind
}), __metadata("design:type", String)], CommentReplyAuthorDto.prototype, "kind", void 0);
class CommentReplyDto {}
exports.CommentReplyDto = CommentReplyDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentReplyDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentReplyDto.prototype, "commentPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentReplyDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], CommentReplyDto.prototype, "isFromAdmin", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CommentReplyDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: CommentReplyAuthorDto
}), __metadata("design:type", CommentReplyAuthorDto)], CommentReplyDto.prototype, "author", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: CommentAttachment_dto_1.CommentAttachmentDto,
  isArray: true
}), __metadata("design:type", Array)], CommentReplyDto.prototype, "attachments", void 0);
//# sourceMappingURL=CommentReply.dto.js.map